/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { Typography, Tooltip } from '@mui/material';
import React from 'react';
import { useCoreTranslation } from '../../../../../utils/i18n';

export interface LayerServiceProps {
  serviceName: string;
  isEnabled?: boolean;
  tooltipPrefix?: string;
}

const LayerService: React.FC<LayerServiceProps> = ({
  serviceName,
  isEnabled = true,
  tooltipPrefix,
}: LayerServiceProps) => {
  const { t } = useCoreTranslation();
  const nonEmptyTooltipPrefix =
    tooltipPrefix ?? `${t('layermanager-service')}:`;
  return (
    <Tooltip
      title={`${nonEmptyTooltipPrefix} ${serviceName === '' ? t('layermanager-sourcename-no-available') : serviceName}`}
    >
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 500,
          color: isEnabled
            ? 'geowebColors.layerManager.tableRowDefaultText.color'
            : 'geowebColors.layerManager.tableRowDisabledText.color',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }}
      >
        {serviceName === ''
          ? t('layermanager-sourcename-no-available')
          : serviceName}
      </Typography>
    </Tooltip>
  );
};

export default LayerService;
